import { Trans } from "@lingui/react/macro";
import { Button, ButtonsContainer } from "@silversea-ssc/ui-components-react";
import PageBuilderPageCTAButton from "components/PageBuilder/PageBuilderPageCTAButton";
import React from "react";
import { OfferPerPromoQuery, PageCtaFragment } from "types/graphql-types";

interface IntroButtonsProps {
  raqURL: string | undefined;
  offer: NonNullable<OfferPerPromoQuery["offer"]>;
}

const overrideButtonVariant = (button: PageCtaFragment): PageCtaFragment => {
  return {
    ...button,
    variant: button.variant == "secondary-gray" ? "secondary" : button.variant
  };
};

export const IntroButtons: React.FC<
  React.PropsWithChildren<IntroButtonsProps>
> = ({ raqURL, offer }) => {
  return (
    <ButtonsContainer spacingTop="regular">
      <Button
        variant="primary"
        href={raqURL}
        dataContentPiece="request_a_quote"
      >
        {offer.customCTALabel ? (
          <React.Fragment>{offer.customCTALabel.localized}</React.Fragment>
        ) : (
          <Trans id="cta-request-quote-for-exclusive-offer">
            REQUEST A QUOTE FOR AN EXCLUSIVE OFFER
          </Trans>
        )}
      </Button>

      {offer.secondaryCTA &&
        offer.secondaryCTA?.label?.localized &&
        offer.secondaryCTA.page && (
          <PageBuilderPageCTAButton
            key={offer.secondaryCTA._key}
            {...overrideButtonVariant(offer.secondaryCTA)}
            defaultVariant="secondary"
          />
        )}

      {offer.tertiaryCTA &&
        offer.tertiaryCTA?.label?.localized &&
        offer.tertiaryCTA.page && (
          <PageBuilderPageCTAButton
            key={offer.tertiaryCTA._key}
            {...overrideButtonVariant(offer.tertiaryCTA)}
            defaultVariant="text"
          />
        )}
    </ButtonsContainer>
  );
};
